export default __webpack_public_path__ + "static/media/img_8.133d6514.jpg";